import { api } from '../api.js';
import { esc, money, dateTime, monthLabel } from '../ui.js';

export async function analyticsView(root) {
  const a = await api('/analytics');
  const byMonth = new Map();
  for (const r of a.revenue) byMonth.set(r.month, (byMonth.get(r.month) || 0) + Number(r.revenue_cents));
  const max = Math.max(1, ...byMonth.values());
  const totalYear = [...byMonth.values()].reduce((n, v) => n + v, 0);
  const u = a.upcoming || { upcoming_slots: 0, seats_booked: 0, seats_total: 0 };
  root.innerHTML = `
    <div class="page-head"><h1>Analytics</h1></div>
    <div class="stats">
      <div class="stat"><span class="v">${money(totalYear)}</span><span class="k">Revenue, last 12 months</span></div>
      <div class="stat"><span class="v">${u.seats_booked} / ${u.seats_total}</span><span class="k">Upcoming seats booked</span></div>
      <div class="stat"><span class="v">${u.upcoming_slots}</span><span class="k">Upcoming dates</span></div>
      <div class="stat"><span class="v">${a.repeatGuests}</span><span class="k">Repeat guests</span></div>
    </div>
    <div class="split">
      <div class="box"><h2>Revenue by month</h2>
        ${byMonth.size ? [...byMonth.entries()].map(([m, v]) => `<div style="display:grid;grid-template-columns:90px 1fr 100px;gap:12px;align-items:center" class="small">
          <span>${esc(monthLabel(m))}</span><div class="bar" style="width:${Math.round((v / max) * 100)}%"></div><span style="text-align:right">${money(v)}</span></div>`).join('')
          : '<p class="small muted">No payments yet.</p>'}
      </div>
      <div class="box"><h2>By experience</h2>
        ${a.byExperience.length ? `<div class="table-wrap"><table class="data" style="min-width:0"><thead><tr><th>Experience</th><th>Bookings</th><th>Guests</th><th>Abandoned</th></tr></thead>
          <tbody>${a.byExperience.map((r) => `<tr><td>${esc(r.experience)}</td><td>${r.confirmed}</td><td>${r.guests}</td><td>${r.abandoned_checkouts}</td></tr>`).join('')}</tbody></table></div>`
          : '<p class="small muted">No bookings yet.</p>'}
      </div>
    </div>
    <div class="box"><h2>Deposit overrides by staff (last 6 months)</h2>
      ${a.overrides.length ? `<div class="table-wrap"><table class="data"><thead><tr><th>Month</th><th>Staff</th><th>Reason</th><th>Count</th><th>Deposits waived</th></tr></thead>
        <tbody>${a.overrides.map((r) => `<tr><td>${esc(monthLabel(r.month))}</td><td>${esc(r.staff_email)}</td><td>${esc(r.reason)}</td><td>${r.overrides}</td><td>${money(Number(r.deposits_waived_cents))}</td></tr>`).join('')}</tbody></table></div>`
        : '<p class="small muted">No overrides yet.</p>'}
    </div>`;
}

export async function auditView(root) {
  const { entries } = await api('/audit');
  root.innerHTML = `<div class="page-head"><h1>Audit log</h1></div>
    <p class="muted">Every change made in the staff portal, newest first.</p>
    ${entries.length ? `<div class="table-wrap"><table class="data"><thead><tr><th>When</th><th>Who</th><th>Action</th><th>Details</th></tr></thead>
      <tbody>${entries.map((e) => `<tr><td class="small">${esc(dateTime(e.created_at))}</td><td class="small">${esc(e.staff_email)}</td>
        <td>${esc(e.action.replace(/_/g, ' '))}<div class="small muted">${esc(e.entity)}</div></td>
        <td class="small muted">${esc(summarize(e.details))}</td></tr>`).join('')}</tbody></table></div>` : '<p class="notice">Nothing yet.</p>'}`;
}

function summarize(d) {
  if (!d) return '';
  const o = typeof d === 'string' ? JSON.parse(d) : d;
  return Object.entries(o).filter(([, v]) => v !== null && v !== '' && typeof v !== 'object').map(([k, v]) => `${k}: ${v}`).join(' · ');
}

export async function staffView(root) {
  const { staff } = await api('/staff');
  root.innerHTML = `<div class="page-head"><h1>Staff &amp; roles</h1></div>
    <div class="table-wrap"><table class="data"><thead><tr><th>Email</th><th>Role</th><th>Last active</th><th>Status</th></tr></thead>
      <tbody>${staff.map((s) => `<tr><td>${esc(s.email)}</td><td><span class="badge gold">${esc(s.role)}</span></td>
        <td class="small">${esc(dateTime(s.last_seen_at))}</td><td>${s.active ? 'Active' : '<span class="badge red">Disabled</span>'}</td></tr>`).join('')}</tbody></table></div>
    <div class="box"><h2>Roles</h2>
      <p class="small"><strong>Owner</strong>: everything, including this page and the audit log.</p>
      <p class="small"><strong>Manager</strong>: bookings, deposit overrides, experiences and dates, guests, automated emails, galleries, analytics.</p>
      <p class="small"><strong>Content editor</strong>: galleries and media only.</p>
      <p class="small"><strong>Guide</strong>: guest lists for their assigned tours, without payment amounts.</p>
      <p class="small muted">New staff are added by Carlton with the create-staff script, which emails them a temporary password. People appear here after their first sign-in.</p>
    </div>`;
}
